// Shared helpers for every *public* (no-login) page — the homepage
// (PublicBooking.js) plus standalone pages like AboutPage.js and
// ServicesPage.js. Centralized here so the "duplicate system" query-param
// behavior (?system=acme-co) stays consistent across all of them instead
// of being copy-pasted and risking drift.
const defaultApiBase = typeof window !== 'undefined' && window.location.hostname !== 'localhost'
    ? `${window.location.origin}/api`
    : 'http://localhost:5000/api';
export const API_BASE = `${(process.env.REACT_APP_API_URL || defaultApiBase).replace(/\/$/, '')}/public`;

// A system-specific public page looks like /about?system=acme-co (or
// wherever the page is mounted) — this only matters for systems a
// developer created via the "duplicate system" feature. With no ?system=
// param (the normal case) every request is unchanged and hits the
// original data.
export const SYSTEM_SLUG = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('system') || ''
    : '';
export const withSystem = (params = {}) => SYSTEM_SLUG ? { ...params, system: SYSTEM_SLUG } : params;

// Some homepage content (hero text, About, slide titles, Privacy Policy,
// Terms of Service) is admin-written free text, not a fixed UI label — so it
// can't go through the i18n dictionary lookup like static button/nav text
// does. Instead /homepage returns an optional `${field}_fr` / `${field}_rw`
// alongside the English `field`, filled in only if the admin wrote that
// language's version in Settings. This picks whichever the visitor's
// current language should see, falling back to English when a translation
// hasn't been written yet.
export const localizedField = (homepage, field, language) => {
    if (!homepage) return '';
    if (language === 'en') return homepage[field] || '';
    return homepage[`${field}_${language}`] || homepage[field] || '';
};
